import type { Content } from '../models';

import { validateContentVersion64 } from './versions/content_v64';
import { validateContentVersion65 } from './versions/content_v65';
import { validateContentVersion66 } from './versions/content_v66';
import { validateContentVersion67 } from './versions/content_v67';
import { validateContentVersion68 } from './versions/content_v68';
import { validateContentVersion69 } from './versions/content_v69';
import { validateContentVersion70 } from './versions/content_v70';
import { validateContentVersion71 } from './versions/content_v71';
import { validateContentVersion72 } from './versions/content_v72';

/**
 * Validates the content of a bucket.
 *
 * @param content - The content to be validated.
 * @returns A boolean indicating whether the content is valid or not.
 */
export const validateBucketContent = (content: Content): boolean => {
  try {
    const versionsToValidate = [
      // add your version below
      validateContentVersion64,
      validateContentVersion65,
      validateContentVersion66,
      validateContentVersion67,
      validateContentVersion68, // X-plot dots
      validateContentVersion69, // Legend custom quills
      validateContentVersion70, // Dot labeling custom line
      validateContentVersion71, // Minimap Defaults
      validateContentVersion72, // Table v2
    ];

    for (const validateFn of versionsToValidate) {
      const ok = validateFn(content);
      if (!ok) {
        console.log('Validation failed for content', content.typeSpecific.version, content.slug);
        return false;
      }
    }
  } catch (error) {
    console.error('Error validating content', content.slug, error);
    return false;
  }

  return true;
};
